﻿/**
 * Move um elemento sobre a tela
 *
 * Como usar:
 * 1) Adicione o attibuto arrastar no elemente que deseja mover.
 * <div arrastavel>Meu elemento arrastável</div>
 *
 * 2) Adicione o styale com a propriedade cursor igual move para
 *    definir o ponto responsável por arrastar o elemento.
 *
 *  <div arrastavel>
 *      <h1 style="cursor: move">Clique aqui para arrastar</h1>
 *      <p>Meu elemento arrastável</p>
 *  </div>
 */

'use strict';

var balcaoApp = angular.module('app.components');

balcaoApp.directive('arrastavel', arrastarDirective);

arrastarDirective.$inject = ['$document'];
function arrastarDirective($document) {

    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            var startX = 0, startY = 0, x = 0, y = 0;

            element.css({
                position: 'relative',
                backgroundColor: '#fff'
            });

            element.on('dblclick', function (event) {
                if (mover(event)) {
                    event.preventDefault();
                    startX = 0; startY = 0; x = 0; y = 0;
                    element.css({
                        top: y + 'px',
                        left: x + 'px'
                    });
                }
            });

            element.on('mousedown', function (event) {

                if (mover(event)) {
                    startX = event.pageX - x;
                    startY = event.pageY - y;
                    $document.on('mousemove', mousemove);
                    $document.on('mouseup', mouseup);
                }

                return;

            });

            function mousemove(event) {
                y = event.pageY - startY;
                x = event.pageX - startX;

                element.css({
                    top: y + 'px',
                    left: x + 'px',
                }).addClass('effect6');
            }

            function mouseup() {
                $document.off('mousemove', mousemove);
                $document.off('mouseup', mouseup);
            }

            function mover(event) {
                return (event.target.style.cursor == 'move');
            }
        }
    };

}



//////////////////
// WEBPACK FOOTER
// ../Projecao.ContactCenter.WebApp.Compartilhado/components/arrastavel/index.js
// module id = 306
// module chunks = 1